module.exports = __webpack_public_path__ + "play.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/button/assets/play.svg
// module id = 1063
// module chunks = 10